































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { OverrideCommissionsTypes } from "@/data/enums/affiliates";

// Types
import { IInvoice } from "@/models/invoices";
import { ICurrency } from "@/models/constants";

@Component
export default class RecalculateCommissionsModal extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];

  @Prop({ required: true })
  public currency!: ICurrency;

  // Variables

  public isProcessing = false;

  public form = {
    override: OverrideCommissionsTypes.OVERWRITE,
    real_time: true
  };

  public get selectorItems() {
    return [
      {
        value: OverrideCommissionsTypes.OVERWRITE,
        label: this.$t("_sentence.affiliate.overwrite_existing_commissions"),
        desc: this.$t("_sentence.affiliate.overwrite_existing_commissions_desc")
      },
      {
        value: OverrideCommissionsTypes.RECALCULATE_AGAIN,
        label: this.$t("_.reallocate_commissions"),
        desc: this.$t("_sentence.affiliate.reallocate_commissions_desc")
      }
    ];
  }

  // Methods

  public async validateBeforeSubmit() {
    if (!this.canCalculateCommissions) return;
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      this.isProcessing = true;
      await this.recalculateCommissions();
      this.$store.dispatch("toast/show", {
        message: this.$t("_.commissions_recalculated")
      });
      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public async recalculateCommissions() {
    return this.$store.dispatch(
      `data/${DataModules.AFFILIATES_COMMISSIONS}/recalculateCommissions`,
      {
        invoiceId: this.invoiceId,
        data: this.form
      }
    );
  }

  // Computed

  public get formIsDisabled() {
    return this.isProcessing || !this.canCalculateCommissions || this.hasErrors;
  }

  public get canCalculateCommissions() {
    return this.$userCan("calculate_pending_commissions");
  }
}
